<template>
    <div class="table-records" @click="closeContextMenu">
        <!-- Debug: CTRL durumunu göster -->
        <div v-if="ctrlPressed" style="position: fixed; top: 10px; right: 10px; background: #1890ff; color: white; padding: 8px; border-radius: 4px; z-index: 9999; font-size: 12px;">
            <div>{{ isMac ? 'Command (⌘)' : 'Ctrl' }} Tuşu Basılı</div>
            <div>Kayıt Sekme Açma Modu Aktif</div>
        </div>

        <!-- Debug: ALT durumunu göster -->
        <div v-if="altPressed" style="position: fixed; top: 10px; right: 10px; background: #52c41a; color: white; padding: 8px; border-radius: 4px; z-index: 9999; font-size: 12px; margin-top: 60px;">
            <div>{{ isMac ? 'Option (⌥)' : 'Alt' }} Tuşu Basılı</div>
            <div>Kayıt Pencere Açma Modu Aktif</div>
        </div>

        <!-- Her bir grup için döngü -->
        <div
            v-for="(groupItem, gIndex) in groupedData"
            :key="`group-${gIndex}-${getGroupHash(groupItem)}`"
            class="group-container"
        >
            <!-- Grup başlığı satırı -->
            <div
                class="table-row group-header-row"
                v-if="groupValue.fieldId && groupItem.key && groupItem.key !== 'N/A'"
                :style="{ backgroundColor: getGroupColor(gIndex) }"
                @click="toggleGroup(gIndex)"
            >
                <div class="table-cell group-header-cell" :colspan="visibleFields.length + 1">
                    <i class="material-icons group-icon">
                        {{ isGroupExpanded(gIndex) ? "expand_more" : "chevron_right" }}
                    </i>
                    {{ groupItem.key }}
                </div>
            </div>

            <!-- Grup içeriği -->
            <div v-show="isGroupExpanded(gIndex)" class="group-content">
                <VirtualScroller 
                    :items="groupItem.records" 
                    :item-size="41" 
                    key-field="_id" 
                    class="scroller-container"
                    :loading="loading"
                    ref="virtualScroller">
                    <template v-slot="{ item: record }">
                        <div
                            class="table-row"
                            :id="`record-${record._id}`"
                            :class="{
                                selected: isSelectionModeActive && isSelected(record._id),
                                'zebra-row':
                                    zebraStripes && !groupValue.fieldId && groupItem.records.indexOf(record) % 2 === 1,
                                'selection-mode': isSelectionModeActive,
                                'ctrl-hover': ctrlPressed,
                                'alt-hover': altPressed,
                            }"
                            :data-record-id="record._id"
                            @mouseover="!isSelectionModeActive && showCheckbox(record._id)"
                            @mouseleave="!isSelectionModeActive && hideCheckbox(record._id)"
                            @click="handleRowClick($event, record)"
                            :style="{ backgroundColor: getRecordColor(record) }"
                        >
                            <div 
                                class="table-cell record-id-cell"
                                :style="{
                                    minWidth: getColumnWidth('record-id') + 'px',
                                    maxWidth: getColumnWidth('record-id') + 'px'
                                }"
                            >
                                <template v-if="pickerMode">
                                    <a-button type="primary" size="small" @click="$emit('record-selected', record)">
                                        Select
                                    </a-button>
                                </template>
                                <template v-else>
                                    <div
                                        v-if="!isSelectionModeActive && !isCheckboxVisible(record._id)"
                                        class="record-id-cell-container"
                                    >
                                        <div class="left">
                                            <div v-if="!pickerMode" class="count-badges">
                                                <a-badge
                                                    v-if="record.commentCount > 0"
                                                    :count="record.commentCount"
                                                    class="count-badge"
                                                    @click="
                                                        isSelectionModeActive ? $.noop : viewRecord(record, 'comments')
                                                    "
                                                >
                                                    <a-icon type="message" />
                                                </a-badge>
                                                <a-badge
                                                    v-if="record.taskCount > 0"
                                                    :count="record.taskCount"
                                                    class="count-badge"
                                                    @click="
                                                        isSelectionModeActive ? $.noop : viewRecord(record, 'tasks')
                                                    "
                                                >
                                                    <a-icon type="check-circle" />
                                                </a-badge>
                                            </div>
                                        </div>
                                        <div class="middle">
                                            {{ record.recordId }}
                                        </div>
                                        <div class="right"></div>
                                    </div>
                                    <div v-else class="record-id-cell-container">
                                        <div class="left">
                                            <div v-if="!isSelectionModeActive && !pickerMode" class="count-badges">
                                                <a-badge
                                                    v-if="record.commentCount > 0"
                                                    :count="record.commentCount"
                                                    class="count-badge"
                                                    @click="viewRecord(record, 'comments')"
                                                >
                                                    <a-icon type="message" />
                                                </a-badge>
                                                <a-badge
                                                    v-if="record.taskCount > 0"
                                                    :count="record.taskCount"
                                                    class="count-badge"
                                                    @click="viewRecord(record, 'tasks')"
                                                >
                                                    <a-icon type="check-circle" />
                                                </a-badge>
                                            </div>
                                        </div>
                                        <div class="middle">
                                            <a-checkbox
                                                class=""
                                                :checked="isSelected(record._id)"
                                                @change="handleCheckboxChange($event, record._id)"
                                                @click.stop
                                            ></a-checkbox>
                                        </div>
                                        <div class="right">
                                            <SupsisButton
                                                @click="viewRecord(record)"
                                                ghost
                                                primary
                                                v-if="!isSelectionModeActive"
                                            >
                                                <i class="material-icons">open_in_new</i>
                                                {{ $t("modules.viewRecord") }}
                                            </SupsisButton>
                                            <SupsisButton
                                                @click="sendOpenChatBubbleRequest(record)"
                                                ghost
                                                primary
                                                v-if="!isSelectionModeActive && isSupsisAgentsTable()"
                                            >
                                                <i class="material-icons">chat</i>
                                                Chat
                                            </SupsisButton>
                                            <SupsisButton
                                                @click="openPanelBehindOfUser(record)"
                                                ghost
                                                primary
                                                v-if="!isSelectionModeActive && isSupsisAgentsTable()"
                                            >
                                                <i class="material-icons">login</i>
                                                Login
                                            </SupsisButton>
                                        </div>
                                    </div>
                                </template>
                            </div>

                            <div
                                class="table-cell table-cell-outer"
                                v-for="(field, index) in visibleFields"
                                :key="`${field._id}-${record._id}`"
                                :style="{
                                    minWidth: getColumnWidth(field._id) + 'px',
                                    maxWidth: getColumnWidth(field._id) + 'px'
                                }"
                                @click="setActiveCell(record._id, field._id)"
                                :class="{ active: isActiveCell(record._id, field._id) }"
                                @keydown.tab.exact.prevent="moveToNextCell(record._id, index)"
                                @keydown.enter.exact.prevent="editCell(record._id, field._id)"
                                tabindex="0"
                                :data-field-type="field.fieldType"
                                @contextmenu.prevent="onCellContextMenu($event, field, record)"
                            >
                                <LoadingCell v-if="loading" :fieldType="field.fieldType" />
                                <StringCell
                                    v-else-if="
                                        ['text', 'long-text', 'email', 'url', 'phone', 'ai', 'record_id'].includes(
                                            field.fieldType
                                        )
                                    "
                                    :record="record"
                                    :field="field"
                                    @update-record="updateRecord($event)"
                                    ref="stringCells"
                                    :readonly="pickerMode || isRecordMetaField(field.fieldType)"
                                    :ai-mode="field.fieldType === 'ai'"
                                />
                                <CheckboxCell
                                    v-else-if="field.fieldType === 'checkbox'"
                                    :record="record"
                                    :field="field"
                                    @update-record="updateRecord($event)"
                                    :readonly="pickerMode"
                                />
                                <NumberCell
                                    v-else-if="field.fieldType === 'number'"
                                    :record="record"
                                    :field="field"
                                    @update-record="updateRecord($event)"
                                    :readonly="pickerMode"
                                />
                                <CurrencyCell
                                    v-else-if="field.fieldType === 'currency'"
                                    :record="record"
                                    :field="field"
                                    @update-record="updateRecord($event)"
                                    :readonly="pickerMode"
                                />
                                <DropdownCell
                                    v-else-if="field.fieldType === 'dropdown'"
                                    :record="record"
                                    :field="field"
                                    @update-record="updateRecord($event)"
                                    :readonly="pickerMode"
                                />
                                <DateCell
                                    v-else-if="
                                        ['datetime', 'record_created_at', 'record_updated_at'].includes(field.fieldType)
                                    "
                                    :record="record"
                                    :field="field"
                                    @update-record="updateRecord($event)"
                                    :readonly="pickerMode || isRecordMetaField(field.fieldType)"
                                />
                                <ButtonCell
                                    v-else-if="field.fieldType === 'automation-button'"
                                    :record="record"
                                    :field="field"
                                    :tableId="table._id"
                                    @update-record="updateRecord($event)"
                                    :readonly="pickerMode"
                                />
                                <AssetCell
                                    v-else-if="['file', 'video', 'image', 'audio'].includes(field.fieldType)"
                                    :record="record"
                                    :field="field"
                                    @update-record="updateRecord($event)"
                                    :readonly="pickerMode"
                                />
                                <UserCell
                                    v-else-if="
                                        ['user', 'record_created_by', 'record_updated_by'].includes(field.fieldType)
                                    "
                                    :record="record"
                                    :field="field"
                                    @update-record="updateRecord($event)"
                                    :readonly="pickerMode || isRecordMetaField(field.fieldType)"
                                />
                                <ContactCell
                                    v-else-if="field.fieldType === 'contact'"
                                    :record="record"
                                    :field="field"
                                    @update-record="updateRecord($event)"
                                    :readonly="pickerMode"
                                />
                                <ConversationCell
                                    v-else-if="field.fieldType === 'conversation'"
                                    :record="record"
                                    :field="field"
                                    @update-record="updateRecord($event)"
                                    :readonly="pickerMode"
                                    @view-conversation="openConversationHistory($event)"
                                />
                                <LinkedRecordCell
                                    v-else-if="field.fieldType === 'linked-record'"
                                    :record="record"
                                    :field="field"
                                    @update-record="updateRecord($event)"
                                    :readonly="pickerMode"
                                />
                                <TaskCell
                                    v-else-if="field.fieldType === 'task'"
                                    :record="record"
                                    :field="field"
                                    @update-record="updateRecord($event)"
                                    :readonly="pickerMode"
                                />
                                <JsonCell
                                    v-else-if="field.fieldType === 'json'"
                                    :record="record"
                                    :field="field"
                                    @update-record="updateRecord($event)"
                                    :readonly="pickerMode"
                                />
                                <FormulaCell
                                    v-else-if="field.fieldType === 'formula'"
                                    :record="record"
                                    :field="field"
                                    :table="table"
                                />
                                <LookupCell v-else-if="field.fieldType === 'lookup'" :record="record" :field="field" />

                                <div v-else class="table-cell-inner">
                                    {{ getFieldValue(record, field._id) }}
                                </div>
                            </div>
                        </div>
                    </template>
                </VirtualScroller>

                <!-- Summary satırını scroller'ın dışına taşıdık -->
                <TableFooterSummary
                    :key="`summary-${getGroupHash(groupItem)}`"
                    :records="groupItem.records"
                    :visibleFields="visibleFields"
                    :columnWidths="columnWidths"
                    class="summary-container"
                />
            </div>
        </div>

        <!-- Global context menü - DOM'un en üstünde, RecycleScroller dışında -->
        <div
            v-if="contextMenuVisible && globalContextMenu"
            class="global-context-menu"
            :style="{
                left: `${contextMenuX}px`,
                top: `${contextMenuY}px`,
            }"
            @click.stop
        >
            <div class="context-menu">
                <div class="context-menu-item" @click.stop="addFilter(contextMenuField, contextMenuRecord)">
                    <i class="material-icons" style="color: #4caf50; vertical-align: middle">add_circle</i>
                    <span style="vertical-align: middle">Filtreye Ekle</span>
                </div>
                <div
                    class="context-menu-item"
                    :class="{ disabled: !isFilterActive(contextMenuField, contextMenuRecord) }"
                    @click.stop="removeFilter(contextMenuField, contextMenuRecord)"
                >
                    <i class="material-icons" style="color: #f44336; vertical-align: middle">remove_circle</i>
                    <span style="vertical-align: middle">Filtreden Çıkar</span>
                </div>
            </div>
        </div>

        <!-- Sohbet Geçmişi Modalı - RecycleScroller dışına taşındı -->
        <UserChatHistoryWidget
            v-if="showConversationHistory && activeConversation"
            :visitor-id="activeConversation.visitor"
            :conversation-id="activeConversation._id"
            @close="closeConversationHistory"
        />
    </div>
</template>

<script>
import Vue from "vue";
import moment from "moment";
import StringCell from "./cells/StringCell.vue";
import CheckboxCell from "./cells/CheckboxCell.vue";
import NumberCell from "./cells/NumberCell.vue";
import CurrencyCell from "./cells/CurrencyCell.vue";
import DropdownCell from "./cells/DropdownCell.vue";
import DateCell from "./cells/DateCell.vue";
import ButtonCell from "./cells/ButtonCell.vue";
import AssetCell from "./cells/AssetCell.vue";
import UserCell from "./cells/UserCell.vue";
import ContactCell from "./cells/ContactCell.vue";
import LinkedRecordCell from "./cells/LinkedRecordCell.vue";
import LoadingCell from "./cells/LoadingCell.vue";
import SupsisButton from "../../Settings/components/SupsisButton.vue";
import { TABLE_API } from "../../../../api/table";
import { mapActions, mapState } from "vuex";
import TableFooterSummary from "./components/TableFooterSummary.vue";
import TaskCell from "./cells/TaskCell.vue";
import JsonCell from "./cells/JsonCell.vue";
import StringUtils from "../../../../utils/StringUtils";
import ConversationCell from "./cells/ConversationCell.vue";
import FormulaCell from "./cells/FormulaCell.vue";
import LookupCell from "./cells/LookupCell.vue";
import VirtualScroller from "./VirtualScroller.vue";
import CONFIG from "../../../../config/config";
import { sendSocketMessage } from "../../../../utils/socketStream";
import { checkTablePermission, getUserDepartments } from "../../../../utils/TablePermissionUtils";
import { TABLE_PERMISSION_SCOPES } from "../../../../utils/TablePermissionScopes";

export default Vue.extend({
    name: "TableRecords",
    props: {
        table: {
            type: Object,
            required: true,
        },
        records: {
            type: Array,
            required: true,
        },
        isSelectionModeActive: Boolean,
        selectedRecords: Array,
        visibleFields: {
            type: Array,
            required: true,
        },
        pickerMode: {
            type: Boolean,
            default: false,
        },
        groupValue: {
            type: Object,
            default: function () {
                return {
                    fieldId: null,
                    direction: "asc",
                    showEmptyGroups: false,
                };
            },
        },
        getRecordColor: {
            type: Function,
            required: true,
        },
        loading: {
            type: Boolean,
            default: false,
        },
        filters: {
            type: Array,
        },
        moduleRelatedListMode: {
            type: Boolean,
            default: false,
        },
        zebraStripes: {
            type: Boolean,
            default: true,
        },
        columnWidths: {
            type: Object,
            default: () => ({}),
        },
    },
    components: {
        StringCell,
        CheckboxCell,
        NumberCell,
        CurrencyCell,
        DropdownCell,
        DateCell,
        ButtonCell,
        AssetCell,
        UserCell,
        ContactCell,
        LinkedRecordCell,
        SupsisButton,
        TableFooterSummary,
        TaskCell,
        LoadingCell,
        JsonCell,
        ConversationCell,
        FormulaCell,
        LookupCell,
        VirtualScroller,
        UserChatHistoryWidget: () => import("../../../../components/UserChatHistoryWidget.vue"),
    },
    data() {
        return {
            activeCell: null,
            checkboxVisibility: {},
            expandedGroups: {},
            lastSelectedRecordId: null,
            groupColors: [
                "rgb(232, 231, 228, 0.5)",
                "rgb(210, 216, 243, 0.5)",
                "rgb(222, 243, 233, 0.5)",
                "rgb(255, 244, 188, 0.5)",
                "rgb(250, 223, 217, 0.5)",
                "rgb(250, 217, 239, 0.5)",
                "rgb(235, 217, 250, 0.5)",
                "rgb(255, 243, 230, 0.5)",
            ],
            contextMenuVisible: false,
            contextMenuX: 0,
            contextMenuY: 0,
            contextMenuField: null,
            contextMenuRecord: null,
            globalContextMenu: true,

            // Sohbet geçmişi modalı için yeni state değişkenleri
            showConversationHistory: false,
            activeConversation: null,

            // CTRL tuşu için yeni state değişkeni
            ctrlPressed: false,

            // ALT tuşu için yeni state değişkeni
            altPressed: false,
        };
    },
    computed: {
        ...mapState({
            tables: (state) => state.table.tables,
            user: (state) => state.auth.user,
            adminUser: (state) => state.auth.adminUser,
        }),
        userDepartments() {
            return getUserDepartments(this.user);
        },
        isMac() {
            return navigator.platform.indexOf('Mac') > -1;
        },
        groupedData: function () {
            if (!this.groupValue.fieldId) {
                return [{ key: null, records: this.records }];
            }

            var fieldId = this.groupValue.fieldId;
            var showEmpty = this.groupValue.showEmptyGroups;
            var groupMap = {};
            var isDescending = this.groupValue.direction === "desc";

            // İlgili alanın fieldType'ını bulalım:
            var targetField = this.visibleFields.find(function (f) {
                return f._id === fieldId;
            });

            for (var i = 0; i < this.records.length; i++) {
                var rec = this.records[i];
                var val = rec.data[fieldId];

                // Eğer val yoksa (veya 0 değilse) "N/A" olarak gösterelim
                if (!val && val !== 0 && !showEmpty) {
                    val = "N/A";
                }
                if (!val && val !== 0) {
                    val = "N/A";
                }

                if (targetField && targetField.fieldType === "datetime" && val !== "N/A") {
                    // Tarih alanları için semantik grup ismini alıyoruz
                    val = this.getSemanticDateGroup(val);
                }

                if (!groupMap[val]) {
                    groupMap[val] = [];
                }
                groupMap[val].push(rec);
            }

            var groupArray = [];
            for (var key in groupMap) {
                if (groupMap.hasOwnProperty(key)) {
                    groupArray.push({
                        key: key,
                        records: groupMap[key],
                    });
                }
            }

            // Sıralama
            groupArray.sort(function (a, b) {
                if (isDescending) {
                    if (a.key < b.key) return 1;
                    if (a.key > b.key) return -1;
                } else {
                    if (a.key < b.key) return -1;
                    if (a.key > b.key) return 1;
                }
                return 0;
            });

            return groupArray;
        },
    },
    methods: {
        ...mapActions({
            addNewWindow: "app/addNewWindow",
        }),
        checkPermission(scope) {
            return checkTablePermission(this.table, scope, this.user, this.adminUser, this.userDepartments);
        },
        // Sohbet geçmişi modalıyla ilgili yeni metotlar
        openConversationHistory(conversation) {
            this.activeConversation = conversation;
            this.showConversationHistory = true;
        },

        closeConversationHistory() {
            this.showConversationHistory = false;
            this.activeConversation = null;
        },

        // CTRL tuşu event handler'ları
        handleKeyDown(event) {
            // Mac'te Command (metaKey) veya Windows'ta Ctrl (ctrlKey) tuşunu kontrol et
            if (event.key === 'Control' || event.key === 'Meta' || event.ctrlKey || event.metaKey) {
                this.ctrlPressed = true;
                console.log('ctrlPressed set to true');
            }
            
            // Alt tuşunu kontrol et
            if (event.key === 'Alt' || event.altKey) {
                this.altPressed = true;
                console.log('altPressed set to true');
            }
        },

        handleKeyUp(event) {
            // Mac'te Command (metaKey) veya Windows'ta Ctrl (ctrlKey) tuşunu kontrol et
            if (event.key === 'Control' || event.key === 'Meta') {
                this.ctrlPressed = false;
                console.log('ctrlPressed set to false');
            }
            
            // Alt tuşunu kontrol et
            if (event.key === 'Alt') {
                this.altPressed = false;
                console.log('altPressed set to false');
            }
        },

        handleWindowBlur() {
            // Pencere focus kaybedince state'i temizle
            this.ctrlPressed = false;
            this.altPressed = false;
            console.log('key states reset on window blur');
        },

        isSupsisAgentsTable() {
            if (CONFIG.IS_STAGE) {
                return (
                    this.table._id === "67b46cfe5f088ae1c6175353" &&
                    this.$store.state.site.site._id === "5d14ee322d95ad001ebdf213"
                );
            } else if (CONFIG.PRODUCTION) {
                return (
                    this.table._id === "67b38669997f17a9706c01dc" &&
                    this.$store.state.site.site._id === "5d14ee322d95ad001ebdf213"
                );
            } else if (CONFIG.IS_DEVELOPMENT) {
                return (
                    this.table._id === "67b38669997f17a9706c01dc" &&
                    this.$store.state.site.site._id === "5d14ee322d95ad001ebdf213"
                );
            }
        },
        sendOpenChatBubbleRequest(record) {
            if (this.isSupsisAgentsTable()) {
                const userIdField = this.table.fields.find((f) => f.apiName === "userId");
                sendSocketMessage("user start-chat-with-supsis-team", {
                    siteId: this.$store.state.site.site._id,
                    connectingUserId: this.$store.state.auth.user._id,
                    targetUserId: record.data[userIdField._id],
                });
                this.$message.success(
                    "Supsis ekibine bağlanma isteği gönderildi. Yaklaşık 10-20sn içinde yanıt alacaksınız. Sizi canlı desteğe yönlendiriyorum. "
                );
                this.$router.push("/chat");
            }
        },
        openPanelBehindOfUser(record) {
            if (this.isSupsisAgentsTable()) {
                const userIdField = this.table.fields.find((f) => f.apiName === "userId");
                const siteIdField = this.table.fields.find((f) => f.apiName === "siteId");
                const password = window.prompt("Lütfen geçiş parolasını giriniz");
                sendSocketMessage("user open-panel-behind-of-user", {
                    siteId: this.$store.state.site.site._id,
                    connectingUserId: this.$store.state.auth.user._id,
                    targetUserId: record.data[userIdField._id],
                    targetSiteId: record.data[siteIdField._id],
                    password,
                    token: this.$store.state.auth.token,
                });
                this.$message.success(
                    "Istek gönderildi lütfen bekleyiniz"
                );
                
            }
        },
        isRecordMetaField(fieldType) {
            return fieldType && fieldType.startsWith("record_");
        },

        /**
         * Tarihsel değerleri semantik gruba ayırır:
         * - Yesterday, Today, Tomorrow, This Week
         * - Diğerleri: "MMMM YYYY" formatında (Örneğin, "Ekim 2023")
         */
        getSemanticDateGroup: function (dateValue) {
            var d = moment(dateValue);
            var now = moment();
            console.log("getSemanticDateGroup", {
                dateValue,
                date1: d.format("YYYY-MM-DD"),
                date2: now.format("YYYY-MM-DD"),
                isToday: d.isSame(now, "day"),
                isYesterday: d.isSame(now.clone().subtract(1, "day"), "day"),
                isTomorrow: d.isSame(now.clone().add(1, "day"), "day"),
                isThisWeek: d.isSame(now, "week"),
            });

            if (d.isSame(now, "day")) {
                return "Today";
            } else if (d.isSame(now.clone().subtract(1, "day"), "day")) {
                return "Yesterday";
            } else if (d.isSame(now.clone().add(1, "day"), "day")) {
                return "Tomorrow";
            } else if (d.isSame(now, "week")) {
                return "This Week";
            }
            return d.format("MMMM YYYY");
        },

        getFieldValue(record, fieldId) {
            return record.data[fieldId] || "";
        },
        setActiveCell(recordId, fieldId) {
            this.activeCell = recordId + "-" + fieldId;
        },
        isActiveCell(recordId, fieldId) {
            return this.activeCell === `${recordId}-${fieldId}`;
        },
        viewRecordById(recordId) {
            console.log("viewRecordById", recordId);
            this.addNewWindow({
                id: recordId,
                type: "table-record-viewer",
                title: `${this.table.name} - ${this.$t("modules.recordViewer")} (${recordId})`,
                payload: {
                    tableId: this.table._id,
                    recordId,
                    defaultOpenTab: null,
                    onClose: () => {
                        const currentUrl = new URL(window.location.href);
                        const currentRecordId = currentUrl.searchParams.get("recordId");
                        if (currentRecordId === recordId) {
                            currentUrl.searchParams.delete("recordId");
                            this.$router.replace({
                                query: {
                                    ...this.$route.query,
                                    recordId: null,
                                },
                            });
                        }
                    },
                },
                multiple: true,
                autoClose: false,
            });
        },
        viewRecord(record, defaultOpenTab = null) {
            const identifierField = this.table.fields.find((field) => field.isIdentifierField);
            let title = `${this.table.name} - ${this.$t("modules.recordViewer")} (${record.recordId})`;
            if (identifierField) {
                const isLinkedRecord = identifierField.fieldType === "linked-record";
                if (isLinkedRecord) {
                    const remoteTable = this.tables.find((t) => t._id === identifierField.options.linkedRecord.table);
                    const labelField = identifierField.options.linkedRecord.labelField;
                    const remoteField = remoteTable.fields.find((f) => f._id === labelField);
                    const isContactField = remoteField.fieldType === "contact";
                    const recordData = record.data[identifierField._id];
                    console.log("viewRecord identifierField", {
                        remoteTable,
                        labelField,
                        remoteField,
                        isContactField,
                        recordData,
                    });
                    if (isContactField) {
                        const contact = _.get(recordData, `data.${labelField}`, undefined);
                        title = contact ? contact.fullname : "İsimsiz Kişi";
                    } else if (remoteField.fieldType === "user") {
                        const user = _.get(recordData, `data.${labelField}`, undefined);
                        title = user ? user.name : "İsimsiz Kullanıcı";
                    } else {
                        title = _.get(recordData, `data.${labelField}`, "Bağlı Kayıt");
                    }
                    title = `${this.table.name} - ${title}`;
                } else {
                    const identifierValue = record.data[identifierField._id];
                    title = `${this.table.name} - ${identifierValue}`;
                }
            }

            // URL'e kayıt bilgisini ekle
            const currentRecordIdOnUrl = new URL(window.location.href).searchParams.get("recordId");
            if (!currentRecordIdOnUrl) {
                const currentUrl = new URL(window.location.href);
                currentUrl.searchParams.set("recordId", record._id);
                this.$router.replace({
                    query: {
                        ...this.$route.query,
                        recordId: record._id,
                    },
                });
            }

            this.addNewWindow({
                id: record._id,
                type: "table-record-viewer",
                title,
                payload: {
                    tableId: this.table._id,
                    recordId: record._id,
                    defaultOpenTab,
                    onClose: () => {
                        const currentUrl = new URL(window.location.href);
                        const currentRecordId = currentUrl.searchParams.get("recordId");
                        if (currentRecordId === record._id) {
                            currentUrl.searchParams.delete("recordId");
                            this.$router.replace({
                                query: {
                                    ...this.$route.query,
                                    recordId: null,
                                },
                            });
                        }
                    },
                },
                multiple: true,
                autoClose: false,
            });
        },
        async updateRecord({ recordId, fieldId, value }) {
            if (!this.checkPermission(TABLE_PERMISSION_SCOPES.RECORD_UPDATE)) {
                this.$message.error(this.$t("tables.permissions.noPermission"));
                return;
            }
            
            // Scroll pozisyonunu güncelleme öncesinde sakla
            const scrollState = this.preserveScrollPosition();

            const updatingFields = {
                [fieldId]: value,
            };
            console.log("updatingFields", {
                recordId,
                fieldId,
                value,
                updatingFields,
            });

            try {
                const record = await TABLE_API.updateRecord(this.table._id, recordId, updatingFields);
                this.$emit("record-updated", record);
                this.$message.success(this.$t("tables.recordUpdatedSucs"));
                
                // Güncelleme sonrası scroll pozisyonunu geri yükle
                this.$nextTick(() => {
                    this.restoreScrollPosition(scrollState);
                });
            } catch (error) {
                this.$message.error(this.$t("tables.failedToUpdateRecord"));
            } finally {
                
            }
        },
        preserveScrollPosition() {
            // VirtualScroller ref'lerinden scroll durumunu al
            const scrollStates = {};
            if (this.$refs.virtualScroller) {
                if (Array.isArray(this.$refs.virtualScroller)) {
                    this.$refs.virtualScroller.forEach((scroller, index) => {
                        if (scroller && scroller.getScrollState) {
                            scrollStates[index] = scroller.getScrollState();
                        }
                    });
                } else if (this.$refs.virtualScroller.getScrollState) {
                    scrollStates[0] = this.$refs.virtualScroller.getScrollState();
                }
            }
            return scrollStates;
        },
        restoreScrollPosition(scrollStates) {
            if (!scrollStates || Object.keys(scrollStates).length === 0) return;
            
            this.$nextTick(() => {
                if (this.$refs.virtualScroller) {
                    if (Array.isArray(this.$refs.virtualScroller)) {
                        this.$refs.virtualScroller.forEach((scroller, index) => {
                            if (scroller && scroller.restoreScrollState && scrollStates[index]) {
                                scroller.restoreScrollState(scrollStates[index]);
                            }
                        });
                    } else if (this.$refs.virtualScroller.restoreScrollState && scrollStates[0]) {
                        this.$refs.virtualScroller.restoreScrollState(scrollStates[0]);
                    }
                }
            });
        },
        moveToNextCell(recordId, currentIndex) {
            const nextIndex = (currentIndex + 1) % this.table.fields.length;
            const nextField = this.table.fields[nextIndex];

            if (nextIndex === 0) {
                const currentRecordIndex = this.records.findIndex((record) => record._id === recordId);
                const nextRecord = this.records[currentRecordIndex + 1];
                if (nextRecord) {
                    this.setActiveCell(nextRecord._id, nextField._id);
                }
            } else {
                this.setActiveCell(recordId, nextField._id);
            }
        },
        editCell(recordId, fieldId) {
            const cellKey = `${recordId}-${fieldId}`;
            const stringCell = this.$refs.stringCells.find((cell) => cell.cellKey === cellKey);
            console.log("editCell stringCells", this.$refs.stringCells);
            if (stringCell && !stringCell.editing) {
                stringCell.startEditing();
            }
        },
        showCheckbox(recordId) {
            if (!this.checkboxVisibility[recordId]) {
                this.$set(this.checkboxVisibility, recordId, true);
            }
        },
        hideCheckbox(recordId) {
            if (this.checkboxVisibility[recordId]) {
                this.$set(this.checkboxVisibility, recordId, false);
            }
        },
        isCheckboxVisible(recordId) {
            return this.isSelectionModeActive || this.checkboxVisibility[recordId];
        },
        isSelected(recordId) {
            return this.selectedRecords.includes(recordId);
        },
        handleRowClick(event, record) {
            // CTRL tuşu basılıysa kayıt sekmede açılsın (Mac Command veya Windows Ctrl)
            if (this.ctrlPressed || event.ctrlKey || event.metaKey) {
                // Sekme modunda açmak için event emit et
                this.$emit("record-opened-in-tab", record);
                return;
            }

            // ALT tuşu basılıysa kayıt yeni pencerede açılsın (Mac Option veya Windows Alt)
            if (event.altKey) {
                this.viewRecord(record);
                return;
            }

            // Yalnızca seçim modunda iken çalışsın
            if (!this.isSelectionModeActive) return;

            // Context menüsü gösterilirken tıklamaları engelle
            if (this.contextMenuVisible) return;

            // Checkbox veya butonlara tıklandığında event'i engelle
            if (
                event.target.closest(".a-checkbox") ||
                event.target.closest("button") ||
                event.target.closest("a-button") ||
                event.target.closest(".supsis-button")
            ) {
                return;
            }

            // Shift tuşu basılıysa, aralık seçimi yapılır
            if (event.shiftKey && this.lastSelectedRecordId) {
                this.selectRange(this.lastSelectedRecordId, record._id);
            } else {
                // Normal tıklama ile sadece bu kaydı seç/kaldır
                this.$emit("toggle-selection", record._id);
                this.lastSelectedRecordId = record._id;
            }
        },
        handleCheckboxChange(event, recordId) {
            this.$emit("toggle-selection", recordId);
            this.lastSelectedRecordId = recordId;
        },
        selectRange(startRecordId, endRecordId) {
            // Gruplara göre düzleştirilmiş kayıt listesi oluşturulur
            const flatRecords = this.groupedData.reduce((acc, group) => {
                return acc.concat(group.records);
            }, []);

            // Başlangıç ve bitiş kayıtlarının indekslerini bul
            const startIndex = flatRecords.findIndex((r) => r._id === startRecordId);
            const endIndex = flatRecords.findIndex((r) => r._id === endRecordId);

            if (startIndex === -1 || endIndex === -1) return;

            // İndeksleri sırala (hangi yönde seçim yapıldığına bakılmaksızın)
            const [minIndex, maxIndex] = startIndex < endIndex ? [startIndex, endIndex] : [endIndex, startIndex];

            // Aradaki tüm kayıtların ID'lerini seç
            const recordIdsToSelect = flatRecords.slice(minIndex, maxIndex + 1).map((r) => r._id);

            // Seçilecek yeni kayıtlar listesi oluştur (mevcut seçimler + yeni seçimler)
            const currentSelection = [...this.selectedRecords];
            recordIdsToSelect.forEach((id) => {
                if (!currentSelection.includes(id)) {
                    currentSelection.push(id);
                }
            });

            // Yeni seçim listesini emit et
            this.$emit("selection-updated", currentSelection);

            // Son seçilen kaydı güncelle
            this.lastSelectedRecordId = endRecordId;
        },
        getGroupColor(index) {
            return this.groupColors[index % this.groupColors.length];
        },
        toggleGroup(groupIndex) {
            this.$set(this.expandedGroups, groupIndex, !this.expandedGroups[groupIndex]);
        },
        isGroupExpanded(groupIndex) {
            return this.expandedGroups[groupIndex] !== false;
        },
        getGroupHash(groupItem) {
            return StringUtils.hashCodeObj({
                key: groupItem.key,
                records: groupItem.records.map((r) => ({
                    _id: r._id,
                    data: r.data,
                })),
            });
        },
        getRecordHash(record) {
            const fields = this.table.fields
                .filter((f) => this.visibleFields.some((vf) => vf._id === f._id))
                .filter((x) => x.valueType !== "objectId")
                .map((x) => x._id);
            const hashData = _.omit(record.data, fields);

            return StringUtils.hashCodeObj({
                _id: record._id,
                updatedAt: record.updatedAt,
                createdAt: record.createdAt,
                data: hashData,
            });
        },
        onCellContextMenu(event, field, record) {
            if (!this.isFilterableField(field)) return;

            event.preventDefault();
            event.stopPropagation();

            // Global context menü için sayfaya göre pozisyon al
            this.contextMenuX = event.pageX - 30;
            this.contextMenuY = event.pageY - 60;
            this.contextMenuField = field;
            this.contextMenuRecord = record;
            this.contextMenuVisible = true;
        },
        addFilter(field, record) {
            
            
            const newFilter = {
                fieldId: field._id,
                operator: "equal", // Varsayılan operatör
                value: record.data[field._id],
            };
            if (field.fieldType === "user") {
                newFilter.value = typeof newFilter.value === "object" ? newFilter.value._id : newFilter.value;
            }
            if (field.fieldType === "linked-record") {
                newFilter.value = typeof newFilter.value === "object" ? newFilter.value._id : newFilter.value;
            }
            if (field.fieldType === "contact") {
                newFilter.value = typeof newFilter.value === "object" ? newFilter.value._id : newFilter.value;
            }
            if (field.fieldType === "ticket") {
                newFilter.value = typeof newFilter.value === "object" ? newFilter.value._id : newFilter.value;
            }
            if (field.fieldType === "task") {
                newFilter.value = typeof newFilter.value === "object" ? newFilter.value._id : newFilter.value;
            }
            if (field.fieldType === "event") {
                newFilter.value = typeof newFilter.value === "object" ? newFilter.value._id : newFilter.value;
            }
            if (field.fieldType === "conversation") {
                newFilter.value = typeof newFilter.value === "object" ? newFilter.value._id : newFilter.value;
            }
            if (field.fieldType === "form-submission") {
                newFilter.value = typeof newFilter.value === "object" ? newFilter.value._id : newFilter.value;
            }
            if(field.valueType === "objectId"){
                newFilter.value = typeof newFilter.value === "object" ? newFilter.value._id : newFilter.value;
            }
            console.log("newFilter", newFilter);
            this.$emit("update-filters", [...this.filters, newFilter]);
            this.contextMenuVisible = false;
        },
        removeFilter(field, record) {
            this.$emit(
                "update-filters",
                this.filters.filter((f) => f.fieldId !== field._id || f.value !== record.data[field._id])
            );
            this.contextMenuVisible = false;
        },
        isFilterableField(field) {
            return !["long-text", "json"].includes(field.fieldType);
        },
        isFilterActive(field, record) {
            return this.filters.some((f) => f.fieldId === field._id && f.value === record.data[field._id]);
        },
        closeContextMenu() {
            this.contextMenuVisible = false;
        },
        checkUrlForRecord() {
            const urlParams = new URLSearchParams(window.location.search);
            const recordId = urlParams.get("recordId");

            if (recordId) {
                console.log("viewRecordById calling from checkUrlForRecord");
                this.viewRecordById(recordId);
            }
        },
        // Kolon genişlik fonksiyonu
        getColumnWidth(fieldId) {
            // Record ID kolonu için daha küçük varsayılan genişlik
            if (fieldId === 'record-id') {
                return this.columnWidths[fieldId] || 100;
            }
            return this.columnWidths[fieldId] || 245;
        },
    },
    mounted() {
        document.addEventListener("click", this.closeContextMenu);
        document.addEventListener("keydown", this.handleKeyDown);
        document.addEventListener("keyup", this.handleKeyUp);
        window.addEventListener("blur", this.handleWindowBlur);
        if (!this.moduleRelatedListMode) this.checkUrlForRecord();
    },
    beforeDestroy() {
        document.removeEventListener("click", this.closeContextMenu);
        document.removeEventListener("keydown", this.handleKeyDown);
        document.removeEventListener("keyup", this.handleKeyUp);
        window.removeEventListener("blur", this.handleWindowBlur);
    },
    watch: {
        records: {
            handler(newRecords, oldRecords) {
                // Kayıtlar değiştiğinde scroll pozisyonunu korumaya çalış
                if (newRecords && oldRecords && newRecords.length === oldRecords.length) {
                    // Aynı sayıda kayıt varsa güncelleme olmuş olabilir, scroll pozisyonunu koru
                    this.$nextTick(() => {
                        if (this.$refs.virtualScroller) {
                            if (Array.isArray(this.$refs.virtualScroller)) {
                                this.$refs.virtualScroller.forEach(scroller => {
                                    if (scroller && scroller.refresh) {
                                        scroller.refresh();
                                    }
                                });
                            } else if (this.$refs.virtualScroller.refresh) {
                                this.$refs.virtualScroller.refresh();
                            }
                        }
                    });
                }
            },
        },
    },
});
</script>

<style lang="scss">
.table-records {
    width: max-content;

    .group-container {
        margin-bottom: 1px;

        .group-content {
            display: flex;
            flex-direction: column;
            height: calc(100vh - 100px);

            .scroller-container {
                flex: 1;
                overflow-y: auto;
            }

            .summary-container {
                position: sticky;
                bottom: 0;
                background: white;
                z-index: 1;
                border-top: 1px solid #ccc;
            }
        }
    }

    .group-header-row {
        cursor: pointer;
        transition: background-color 0.2s ease;

        &:hover {
            filter: brightness(0.95);
        }

        .group-header-cell {
            font-weight: bold;
            display: flex;
            align-items: center;
            padding: 8px 15px;

            .group-icon {
                margin-right: 8px;
                transition: transform 0.2s ease;
            }
        }
    }

    .group-content {
        transition: all 0.3s ease;
    }

    .table-row {
        display: flex;
        border-bottom: 1px solid #ccc;

        &.selection-mode {
            cursor: pointer;
        }

        .table-cell {
            padding: 2px 15px;
            min-height: 40px;
            max-height: 100px;
            height: auto;
            display: flex;
            align-items: center;

            border-right: 1px solid #ccc;
            position: relative;

            &:last-child {
                //border-right: none;
            }

            &.active {
                border: 2px solid #007bff;
            }

            &.selected {
                background-color: #e6f7ff;
            }

            &.ctrl-hover {
                background-color: rgba(24, 144, 255, 0.2) !important;
                cursor: pointer !important;
                border-left: 4px solid #1890ff !important;
                transition: all 0.2s ease !important;

                &:hover {
                    background-color: rgba(24, 144, 255, 0.3) !important;
                }

                .table-cell {
                    border-right-color: rgba(24, 144, 255, 0.3) !important;
                }
            }

            &.alt-hover {
                background-color: rgba(82, 196, 26, 0.2) !important;
                cursor: pointer !important;
                border-left: 4px solid #52c41a !important;
                transition: all 0.2s ease !important;

                &:hover {
                    background-color: rgba(82, 196, 26, 0.3) !important;
                }

                .table-cell {
                    border-right-color: rgba(82, 196, 26, 0.3) !important;
                }
            }

            &[data-field-type="automation-button"] {
                width: 100%;
            }
        }

        &.zebra-row {
            background-color: rgba(0, 0, 0, 0.02);

            &:hover {
                background-color: #f5f5f5;
            }

            &.selected {
                background-color: #e6f7ff !important;
            }
        }

        &:hover {
            background-color: #f5f5f5;
        }

        &.selected {
            background-color: #e6f7ff;
        }
    }
}

.record-id-cell {
    justify-content: center;
    position: relative;

    .record-id-cell-container {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        position: relative;
        width: 100%;

        .left {
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: flex-start;

            .count-badges {
                display: flex;
                gap: 4px;

                .count-badge {
                    cursor: pointer;
                    background: rgba(0, 0, 0, 0.1);
                    padding: 2px 4px;
                    border-radius: 4px;
                    transition: background 0.2s;

                    &:hover {
                        background: rgba(0, 0, 0, 0.2);
                    }

                    .ant-badge-count {
                        background: #1890ff;
                    }
                }
            }
        }

        .middle {
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
        }

        .right {
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: flex-end;
        }
    }

    .ant-btn {
        padding: 0 8px;
    }
}

.checkbox-container {
    display: flex;
    align-items: center;

    .ant-btn {
        margin-left: 8px;
    }
}

.global-context-menu {
    position: absolute;
    z-index: 9999;
    background: white;
    border: 1px solid #ddd;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    border-radius: 4px;

    .context-menu {
        display: flex;
        flex-direction: column;
        min-width: 180px;
        padding: 4px 0;

        .context-menu-item {
            display: flex;
            align-items: center;
            padding: 8px 16px;
            cursor: pointer;
            transition: background-color 0.2s ease;
            white-space: nowrap;

            &:hover {
                background-color: #f5f5f5;
            }

            &.disabled {
                color: #ccc;
                cursor: not-allowed;

                i {
                    color: #ccc;
                }
            }

            i {
                margin-right: 8px;
            }
        }
    }
}

.highlight-update {
    animation: highlight-fade 1s ease-out;
}

@keyframes highlight-fade {
    0% {
        background-color: rgba(24, 144, 255, 0.2);
    }
    100% {
        background-color: transparent;
    }
}
</style>
